import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getCreditRefundContract, getGemsTokenContract } from "../../utils/contractHelpers";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const CreditRefund = () => {
    const web3 = useWeb3()
    const { account } = useWeb3React()
    // const tokenAddress = environment.gems;
    // const contract = getGemsTokenContract(tokenAddress, web3);
    const contract = getCreditRefundContract(Environment.CreditRefund, web3);
    const Credit_Refund = useCallback(
        async (amount, token, totalAmount, deadline, v, r, s, decimals) => {
            console.log(amount, token, totalAmount, deadline, v, r, s, decimals, "Amount")
            // amount = web3.utils.toWei(amount.toString(), "ether"); // amount * 10 ** decimals; // 0.00005
            // totalAmount = web3.utils.toWei(totalAmount.toString(), "ether"); // amount * 10 ** decimals; // 0.00005
            // nd = web3.utils.toWei(nd.toString(), "ether");
            try {
                const details = await contract.methods
                    .creditRefund(
                        token,
                        amount,
                        totalAmount,
                        deadline,
                        v,
                        r,
                        s
                    )
                    .send({
                        from : account
                    })

                return details;
            } catch (error) {
                console.log(error, 'Error');

                throw error;
            }
        },
        [web3]
    );
    return { Credit_Refund: Credit_Refund };
};
export default CreditRefund;
